import {
  DATA_BINDING,
  WIX_STORES,
  WIX_NEW_STORES,
} from '@wix/app-definition-ids'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import { isBlocks } from '@wix/wix-data-client-common'
import type { AppApi, EDITOR_TYPE } from '@wix/wix-data-client-common'
import type {
  DigestedSchema,
  EditorSDK,
} from '@wix/wix-data-client-common-standalone'
import { FieldType } from '@wix/wix-data-schema-types'

const collectionHasSlugField = (collection: DigestedSchema): boolean => {
  const field = collection.fields.find(field => field.name === 'slug')
  return field?.type === FieldType.text
}

const supportedAppCollectionsForStaticPages = [
  {
    pageAppDefinitionIds: [WIX_STORES, WIX_NEW_STORES],
    collections: [
      {
        id: 'StoreCatalog/Products',
        appDefinitionId: WIX_NEW_STORES,
      },
      { id: 'Stores/Products', appDefinitionId: WIX_STORES },
    ],
  },
]

export const isSlugFilterAllowedInPage = async ({
  editorSdkProxy,
  collection,
  editorType,
  appApi,
  controllerRef,
}: {
  editorSdkProxy: EditorSDK
  isTPACollection: boolean
  collection: DigestedSchema
  editorType: EDITOR_TYPE
  appApi: AppApi
  controllerRef: ComponentRef
}): Promise<boolean> => {
  const pageRef = await editorSdkProxy.document.pages.getCurrent()
  const [isDynamicPage, pageData, datasetInfo] = await Promise.all([
    editorSdkProxy.document.pages.isDynamicPage({
      pageRef,
    }),
    editorSdkProxy.document.pages.getPageData({ pageRef }),
    appApi.fetchDataset(controllerRef),
  ])

  const pageAppDefinitionId = (pageData.managingAppDefId ||
    pageData.appDefinitionId) as string
  const pageIsNotManagedByCms =
    !!pageAppDefinitionId && pageAppDefinitionId !== DATA_BINDING
  const isStaticPageOwnedByVertical = !isDynamicPage && pageIsNotManagedByCms
  const isDynamicPageOwnedByVertical = isDynamicPage && pageIsNotManagedByCms
  const inBlocks = isBlocks(editorType)

  const appCollectionDescriptor =
    isStaticPageOwnedByVertical &&
    supportedAppCollectionsForStaticPages.find(
      d =>
        d.pageAppDefinitionIds.includes(pageAppDefinitionId) &&
        d.collections.find(
          c =>
            c.id === collection.id &&
            c.appDefinitionId === collection.ownerAppId,
        ),
    )

  const currentPageIsSupported =
    isDynamicPageOwnedByVertical || !!appCollectionDescriptor || inBlocks

  const isDatasetGlobal = datasetInfo.isOnMasterPage

  return (
    currentPageIsSupported &&
    collectionHasSlugField(collection) &&
    !isDatasetGlobal
  )
}
